import { createContext } from 'preact';

export interface Translations {
    [key: string]: string | Translations; 
}

export interface IntlContextType {
    translations: Translations;
    // 或者你也可以直接在这里提供一个 t 函数
    // t: (key: string, params?: Record<string, string | number>) => string;
  }

  export const IntlContext = createContext<IntlContextType | undefined>(undefined);
